module.exports = __webpack_public_path__ + "static/managed-banner-2a949e0678541014bdd37717be28ef4e.png";